module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-900.22acb397.ttf";